// fa, en
export default {
  fa: {
    me: "من",
    about: "درباره",
    education: "تحصیلات",
    experience: "تجربه‌ها",
    skill: "تخصص‌ها",
    achievement: "دستاوردها",
    project: "پروژه‌ها",
    blog: "بلاگ",
    courses: "دوره‌ها",
    abolfazl: "ابوالفضل",
    mohajeri: "مهاجری",
    developer: "توسعه دهنده",
    software_engineer: "مهندس نرم‌افزار",
    senior_software_engineer: "مهندس ارشد نرم‌افزار",
    amper: "و",
    researcher: "پژوهشگر",
    about_text: "من چندین سال است که در زمینه مهندسی نرم‌افزار فعالیت می‌کنم و در طول حرفه‌ام، تجربیات عملی ارزشمندی در زمینه تکنولوژی‌های مختلف، وظایف چالش‌برانگیز و همکاری با افراد بااستعداد به دست آورده‌ام.",
    download_cv: "دانلود رزومه",
    contact: "تماس",
    contact_me: "تماس با من",
    more: "بیشتر",
    less: "کمتر",
    attachment: "ضمیمه",
    download: "دانلود",
    email: "ایمیل",
    gpa: "معدل",
    mobile: "09376215871",
    live_demo: "دمو آنلاین",
    github: "گیت‌هاب",
    telegram_channel: "کانال تلگرامم رو دنبال کن",

    // Education Section
    grades_modal_text: "بعضی نمرات مهم",
    software_engineering: "مهندسی نرم افزار",
    mathematics_physics: "ریاضی فیزیک",

    ms: "کارشناسی ارشد",
    fum: "دانشگاه فردوسی مشهد",
    fum_year: "1399 - 1401",
    cur_study: "در حال تحصیل",
    advanced_software_engineering: "مهندسی نرم افزار پیشرفته",
    search_engines_and_web_mining: "موتورهای جستجو و وب کاوی",
    data_mining: "داده کاوی",
    semantic_web: "وب معنایی",
    knowledge_base_management: "مدیریت پایگاه دانش",

    bachelor: "مقطع لیسانس",
    iaum: "دانشگاه آزاد اسلامی واحد مشهد",
    iaum_year: "1395 - 1399",
    advanced_programming: "برنامه سازی پيشرفته",
    data_structures: "ساختمان هاي داده",
    algorithms: "طراحی الگوريتم ها",
    signals_and_systems: "سيگنال ها و سيستم ها",
    artificial_intelligence_and_expert_systems: "هوش مصنوعی و سيستم هاي خبره",
    database: "پایگاه داده",
    robotics_basics: "اصول رباتیکز",

    diploma: "دیپلم",
    mobin: "دبیرستان نمونه دولتی مبین",
    mobinYear: "1391 - 1395",

    // Experience Section
    full_time: "تمام وقت",
    part_time: "پاره وقت",
    web_developer: "توسعه دهنده وب",

    freelancing: "فریلنسینگ",
    freelancing_place: "همه جا",
    freelancing_date: "1393 - حال",

    tech_lead: "راهبر فنی",
    backend: "توسعه‌دهنده بک‌اند",
    neshan: "<small> نقشه و مسیریاب </small> نشان",
    neshan_date: "1401 - حال",
    neshan_tech_date: "1403 - حال",
    neshan_soft_date: "1401 - 1403",
    neshan_tech_desc: "" +
        "• رهبری تیم مهندسی جمع‌سپاری و گیمیفیکیشن.\n" +
        "• مدیریت معماری و استانداردهای کیفیت کد در بیش از 20 میکروسرویس.\n" +
        "• مدیریت فرآیندهای مرج و بررسی PRهای تأثیرگذار برای حفظ سازگاری در سطح سیستم.\n" +
        "• همکاری با تیم‌های محصول و هوش مصنوعی برای طراحی و ارائه قابلیت‌های مقیاس‌پذیر و تأثیرگذار.\n" +
        "• منتورینگ توسعه‌دهندگان و اجرای جلسات اشتراک دانش.",

    member: "عضو تیم",
    quera: "کوئرا",
    quera_date: "1399 - 1401",
    quera_desc: "" +
        "• طراحی، توسعه و نگهداری سیستم داوری آنلاین مورد استفاده برای ارزیابی راه‌حل‌ها در مسابقات و کالج کوئرا.\n" +
        "• مشارکت در طراحی مسابقات برنامه‌نویسی و چالش‌های آموزشی که روزانه توسط دانشجویان، اساتید و شرکت‌های برتر فناوری در سراسر ایران استفاده می‌شود.\n" +
        "• توسعه و نگهداری چندین دوره آموزشی محبوب در حوزه بک‌اند در کالج کوئرا.",

    mobintabaran: "سازه های هوشمند مبین طابران",
    mobintabaran_date: "1398 - 1400",
    mobintabaran_desc: "" +
        "• به دلیل تعداد نفرات کم در تیم، به عنوان یک مهندس فول‌استک فعالیت کردم و در هر دو بخش بک‌اند و فرانت‌اند مشارکت داشتم.\n" +
        "• روی پلتفرم‌های مبتنی بر مکان و سیستم‌های سازمانی در مقیاس بزرگ کار کردم.",

    // Skills Section
    try: "من با این تکنولوژی‌ها هم کار کردم",

    // Project Section
    projects: [
      {
        title: "لایوی",
        logo: require('@/assets/images/livey.png'),
        description: "نمایش زنده جهان",
        tags: ["Go", "AI", "VueJS"],
        demo: "https://livey.ir"
      }, {
        title: "فرمی",
        logo: require('@/assets/images/formy.png'),
        description: "هندلر فرم با مدیریت آسان",
        tags: ["Go", "ReactJS"],
        github: "https://github.com/abmohajeri/formy",
        demo: "https://formy.pages.dev"
      }, {
        title: "Map Tools",
        logo: require('@/assets/images/maptools.png'),
        description: "دستیار آنلاین برای نقشه",
        tags: ["Pure JS"],
        github: "https://github.com/abmohajeri/map-tools",
        demo: "https://abmohajeri.github.io/map-tools"
      }, {
        title: "Logn",
        logo: require('@/assets/images/logn.png'),
        description: "نمایش بصری برای پیچیدگی الگوریتم‌ها",
        tags: ["Pure JS"],
        github: "https://github.com/abmohajeri/logn",
        demo: "https://logn.ir"
      }, {
        title: "CNN قابل توضیح",
        description: "مدل CNN قابل توضیح روی مجموعه داده MNIST",
        tags: ["Python", "Torch"],
        github: "https://github.com/abmohajeri/explainable-cnn",
        demo: "https://blog.abolfazlmohajeri.ir/explainable-cnn-model-on-fashion-mnist-dataset"
      }, {
        title: "QA قابل توضیح",
        description: "سیستم پرسش و پاسخ قابل توضیح",
        tags: ["Python", "Torch"],
        github: "https://github.com/abmohajeri/explainable-question-answering",
        demo: "https://blog.abolfazlmohajeri.ir/explainable-question-answering-system"
      }
    ],

    // Achievement Section
    scoreboard: "جدول امتیازات",
    certificate: "گواهی",
    participant: "شرکت کننده",
    team: "تیم",

    techolympics_rank: "مقام سیزدهم",
    techolympics_time: "مهر 1403",

    connect6_rank: "مقام اول",
    connect6_time: "اردیبهشت 97",

    acm_rank: "مقام بیست و چهارم",
    acm_time: "آذر 96",

    acm_judge: "داور مسابقات برنامه نویسی در CCC8",
    judge_time: "آذر 97",

    fanavard_rank: "گواهی",
    fanavard_time: "آذر 96",

    aichallenge_rank: "گواهی رقابت‌های هوش مصنوعی",
    aichallenge_time: "فروردین 1400",

    iccke: "گواهی برگزاری کارگاه در کنفرانس ICCKE 2022",
    iccke_time: "آبان 1401",
    iccke_sub: "کارگاه 4 ساعته با موضوع هوش مصنوعی قابل توضیح",
    iccke_site: "سایت کنفرانس",

    explainable_holodetect: "روش تشخیص خطای قابل توضیح <br> برای داده های ساختاریافته با استفاده از چارچوب HoloDetect",
    explainable_holodetect_time: "آذر 1402",
    explainable_holodetect_sub: "سیزدهمین کنفرانس بین المللی مهندسی کامپیوتر و دانش (ICCKE)",
    explainable_holodetect_site: "لینک مقاله در IEEE",

    codecup4_judge: "مقام چهاردهم",
    codecup4_time: "خرداد 97",

    // Contact Section
    contactText: "برای اطلاعات بیشتر با من در تماس باشید.",
    contactPlace: "ایران، مشهد",
    contactLink: "هم‌چنین از طریق این <a href='https://blog.abolfazlmohajeri.ir/contact-me' target='_blank'> لینک </a>، می‌توانید برای ارتباط با من استفاده کنید.",

    // Blog Section
    visit_blog: "همه پست‌ها",

    // Courses Section
    register: "ثبت‌نام",
    laravel_course: "جامپ بک‌اند با لاراول",
    laravel_teachers: "ابوالفضل مهاجری، نیما حیدری‌نسب و ...",

    linux_course: "آموزش کاربردی لینوکس (از 0 تا Z)",
    linux_teachers: "ابوالفضل مهاجری، سید علی بابایی و ...",

    db_course: "آموزش عملی دیتابیس",
    db_teachers: "ابوالفضل مهاجری، نیما حیدری‌نسب و ...",

    // Footer Section
    made: "ساخته شده با ",
    by: "توسط ",
  },
  en: {
    me: "Me",
    about: "About",
    education: "Education",
    experience: "Experiences",
    skill: "Skills",
    achievement: "Achievements",
    project: "Projects",
    blog: "Blog",
    courses: "Courses",
    abolfazl: "Abolfazl",
    mohajeri: "Mohajeri",
    developer: "Developer",
    software_engineer: "Software Engineer",
    senior_software_engineer: "Senior Software Engineer",
    amper: "&",
    researcher: "Researcher",
    about_text: "I have been working in the field of software engineering for several years, and throughout my career, I have gained valuable hands-on experience with exciting technologies, challenging tasks, and collaborating with talented individuals.",
    download_cv: "Download Resume",
    contact: "Contact",
    contact_me: "Contact Me",
    more: "More",
    less: "Less",
    attachment: "Attachment",
    download: "Download",
    email: "Email",
    gpa: "GPA",
    mobile: "+989376215871",
    live_demo: "Live Demo",
    github: "GitHub",
    telegram_channel: "Follow My Telegram Channel",

    // Education Section
    grades_modal_text: "Some Important Grades",
    software_engineering: "Software Engineering",
    mathematics_physics: "Mathematics And Physics",

    ms: "Master of Science",
    fum: "Ferdowsi University Of Mashhad",
    fum_year: "2020 - 2022",
    cur_study: "Currently Studying",
    advanced_software_engineering: "Advanced Software Engineering",
    search_engines_and_web_mining: "Search Engines and Web Mining",
    data_mining: "Data Mining",
    semantic_web: "Semantic Web",
    knowledge_base_management: "Knowledge Base Management",

    bachelor: "Bachelor’s Degree",
    iaum: "Islamic Azad University Of Mashhad",
    iaum_year: "2016 - 2020",
    advanced_programming: "Advanced Programming",
    data_structures: "Data Structures",
    algorithms: "Algorithms Design",
    signals_and_systems: "Signals And Systems",
    artificial_intelligence_and_expert_systems: "Artificial Intelligence and Expert Systems",
    database: "Database",
    robotics_basics: "Robotics Basics",

    diploma: "Diploma",
    mobin: "Mobin High School (Magnet School)",
    mobinYear: "2012 – 2016",

    // Experience Section
    full_time: "Full Time",
    part_time: "Part Time",
    web_developer: "Web Developer",

    freelancing: "Freelancing",
    freelancing_place: "All Over The World",
    freelancing_date: "2015 - Present",

    tech_lead: "Technical Lead",
    backend: "Backend Developer",
    neshan: "Neshan <small> Maps & Navigation </small>",
    neshan_date: "2022 - Present",
    neshan_tech_date: "2024 - Present",
    neshan_soft_date: "2022 - 2024",
    neshan_tech_desc: "" +
        "• Leading the crowdsourcing & gamification engineering team.\n" +
        "• Owning architecture direction and code quality standards across 20+ microservices.\n" +
        "• Managing merge processes and reviewing high-impact PRs to maintain system-wide consistency and reliability.\n" +
        "• Partnering with product and AI teams to design and deliver scalable, high-impact features.\n" +
        "• Mentoring developers, and running knowledge-sharing sessions.",

    member: "Member Of",
    quera: "Quera",
    quera_date: "2020 - 2022",
    quera_desc: "" +
        "• Designing, developing, and maintaining the online judge system used for evaluating solutions in quera contests and quera college.\n" +
        "• Contributing to the design of programming contests and educational challenges used daily by students, instructors, and top tech companies across Iran.\n" +
        "• Developing and maintaining several of quera’s most popular backend learning courses in quera college.",

    mobintabaran: "Mobin Tabaran Intelligence Structures",
    mobintabaran_date: "2018 - 2020",
    mobintabaran_desc: "" +
        "• Acted as a full-stack engineer due to team size limitations, contributing across both backend and frontend.\n" +
        "• Worked on large-scale location-based platforms and organizational systems.",

    // Skills Section
    try: "I also tried this technologies",

    // Project Section
    projects: [
      {
        title: "Livey",
        logo: require('@/assets/images/livey.png'),
        description: "Live view of the world",
        tags: ["Go", "AI", "VueJS"],
        demo: "https://livey.ir"
      }, {
        title: "Formy",
        logo: require('@/assets/images/formy.png'),
        description: "Effortless & serverless form handler",
        tags: ["Go", "ReactJS"],
        github: "https://github.com/abmohajeri/formy",
        demo: "https://formy.pages.dev"
      }, {
        title: "Map Tools",
        logo: require('@/assets/images/maptools.png'),
        description: "Online assistant for map",
        tags: ["Pure JS"],
        github: "https://github.com/abmohajeri/map-tools",
        demo: "https://abmohajeri.github.io/map-tools"
      }, {
        title: "Logn",
        logo: require('@/assets/images/logn.png'),
        description: "Visual intuition for algorithm complexity",
        tags: ["Pure JS"],
        github: "https://github.com/abmohajeri/logn",
        demo: "https://logn.ir"
      }, {
        title: "Explainable CNN",
        description: "Explainable CNN Model on Fashion MNIST Dataset",
        tags: ["Python", "Torch"],
        github: "https://github.com/abmohajeri/explainable-cnn",
        demo: "https://blog.abolfazlmohajeri.ir/explainable-cnn-model-on-fashion-mnist-dataset"
      }, {
        title: "Explainable QA",
        description: "Explainable Question Answering System",
        tags: ["Python", "Torch"],
        github: "https://github.com/abmohajeri/explainable-question-answering",
        demo: "https://blog.abolfazlmohajeri.ir/explainable-question-answering-system"
      }
    ],

    // Achievement Section
    scoreboard: "Scoreboard",
    certificate: "Certificate",
    participant: "Participant",
    team: "Team",

    techolympics_rank: "Thirteen Place",
    techolympics_time: "October 2024",

    connect6_rank: "First Place",
    connect6_time: "May 2018",

    acm_rank: "Twenty Fourth Place",
    acm_time: "December 2017",

    acm_judge: "Judge Of Contest in CCC8",
    judge_time: "December 2018",

    fanavard_rank: "Certification",
    fanavard_time: "December 2016",

    aichallenge_rank: "AI Challenge Certification",
    aichallenge_time: "April 2021",

    iccke: "Certificate OF ICCKE Workshop Presentation",
    iccke_time: "November 2022",
    iccke_sub: "4 Hour Workshop Entitled Explainable Artificial Intelligence",
    iccke_site: "Conference Site",

    explainable_holodetect: "Explainable Error Detection Method <br> For Structured Data Using HoloDetect Framework",
    explainable_holodetect_time: "November 2023",
    explainable_holodetect_sub: "13th International Conference on Computer and Knowledge Engineering (ICCKE)",
    explainable_holodetect_site: "Paper Link in IEEE",

    codecup4_judge: "Fourteenth Place",
    codecup4_time: "June 2018",

    // Contact Section
    contactText: "Do Not Hesitate To Contact Me For More Information.",
    contactPlace: "Mashhad, Iran",
    contactLink: "You can also use this <a href='https://blog.abolfazlmohajeri.ir/contact-me' target='_blank'> link </a> to contact me.",

    // Blog Section
    visit_blog: "All Posts",

    // Courses Section
    register: "Register",

    laravel_course: "Backend Jump With Laravel",
    laravel_teachers: "Abolfazl Mohajeri, Nima HeydariNasab and ...",

    linux_course: "Practical Linux Course",
    linux_teachers: "Abolfazl Mohajeri, Seyed Ali Babaei and ...",

    db_course: "Practical Database Course",
    db_teachers: "Abolfazl Mohajeri, Nima HeydariNasab and ...",

    // Footer Section
    made: "Made with ",
    by: "by ",
  }
}
